export default __webpack_public_path__ + "static/media/china.c8760bf0.svg";